import { useEffect } from 'react';

function upsertMeta(selector, attr, name, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function SEO({ title, description, keywords, canonical }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta[name="title"]', 'name', 'title', title);
      upsertMeta('meta[property="og:title"]', 'property', 'og:title', title);
      upsertMeta('meta[property="twitter:title"]', 'property', 'twitter:title', title);
    }

    if (description) {
      upsertMeta('meta[name="description"]', 'name', 'description', description);
      upsertMeta('meta[property="og:description"]', 'property', 'og:description', description);
      upsertMeta('meta[property="twitter:description"]', 'property', 'twitter:description', description);
    }

    if (keywords) {
      upsertMeta('meta[name="keywords"]', 'name', 'keywords', keywords);
    }

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
      upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonical);
      upsertMeta('meta[property="twitter:url"]', 'property', 'twitter:url', canonical);
    }
  }, [title, description, keywords, canonical]);

  return null;
}

export default SEO;
